import { render, staticRenderFns } from "./StaffAttendance.vue?vue&type=template&id=04face64&"
import script from "./StaffAttendance.vue?vue&type=script&lang=js&"
export * from "./StaffAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports